import { createHashHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import rootReducer, { initialState } from './reducers';
import { runSagas } from './sagas';

export default function createAppStore() {
  const history = createHashHistory();

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    connectRouter(history)(rootReducer), // new root reducer with router state
    initialState,
    composeEnhancers(applyMiddleware(
      routerMiddleware(history),
      sagaMiddleware
    )),
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept(['./reducers', './store.js'], () => {
      const nextRootReducer = require('./reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }

  runSagas(sagaMiddleware);
  return { store, history };
}



// WEBPACK FOOTER //
// ./src/store.js